import RiverPreview from './RiverPreview';
import SensationsPreview from './SensationsPreview';
import DriftPreview from './DriftPreview';
import CrumplePreview from './CrumplePreview';
import MeltPreview from './MeltPreview';
import SnakePreview from './SnakePreview';

const PreviewCanvas = ({ interactive }) => {
  switch (interactive) {
    case 'river':      return <RiverPreview />;
    case 'sensations': return <SensationsPreview />;
    case 'drift':      return <DriftPreview />;
    case 'crumple':    return <CrumplePreview />;
    case 'melt':       return <MeltPreview />;
    case 'snake':      return <SnakePreview />;
    default:           return null;
  }
};

export default PreviewCanvas;
